export default {
  title: 'Wöchentliche Leistung',
  messages_sent: 'Gesendete Nachrichten',
  click_rate: 'Durchschnittliche Klickrate',
  messages_delivered: 'Zugestellte Nachrichten',
  awaiting: 'Wartet auf Bestätigung',
  legend: {
    sent: 'Gesendet',
    clicked: 'Geklickt',
    delivered: 'Zugestellt',
  },
  error_messages: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
  },
};
